import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { GlobalConstants } from 'src/app/common/global';
import { ModalNames } from 'src/app/common/modal.config';
import { Services } from 'src/app/services/api.service';
import { ModalService } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-voting-right-to-vote',
  templateUrl: `${environment.pageFolder}/voting-right-to-vote.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/voting-right-to-vote.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: []
})
export class VotingRightToVoteComponent implements OnInit {
  votingRightMessage = "";
  loader = document.getElementById("loader-container")
  isLogged: boolean = GlobalConstants.isAuth;
  membershipError: boolean = false;
  votingRightMessages: any = {
    '1': "Zadovoljavate uvjete za glasanje!",
    '0': "Greška! Molimo kontaktirajte podršku na info e-mail: podrska@ulaznice.hr.",
    '-1': "Da biste pristupili glasanju, potrebno je povezati svoje članstvo na sljedećoj poveznici: ",
    '-2': "Ne zadovoljavate uvjete za glasanje: Vaše članstvo ne traje do kraja tekuće godine!",
    '-3': "Ne zadovoljavate uvjete za glasanje: niste imali aktivno članstvo prošle godine!",
    '-4': "Vaš glas je zabilježen. Hvala!",
    '-5': "Ne zadovoljavate uvjete za glasanje: samo punoljetni članovi imaju pravo glasa ili je upisan neispravan datum rođenja prilikom učlanjenja!",
    '-6': "Članska iskaznica s upisanim brojem nije pronađena!",
    '-7': "Ne zadovoljavate uvjete za glasanje: članstvo je produljeno nakon 16.02.2024.!"
  };
  environmentURL = environment.redirectUrl;
  hasRightToVote: boolean = false;
  votingStatus: any;
  
  constructor(private apiService: Services, private router: Router, private readonly modalService: ModalService) { }

  ngOnInit(): void {
    this.loader!.style.display = "none";            

    /* if(sessionStorage.getItem("sendPIN") && this.isLogged) {
      this.sendPIN();
      sessionStorage.removeItem("sendPIN");
    } 

    if(this.isLogged) {
      this.apiService.getIsVotingActiveService().subscribe({
        next: (data: any) => {
          let response:any = data;
          this.votingStatus = Number(response.data.status);

         if(response.data.status === 1 || response.data.status === -1) {
           this.apiService.getMembersRightToVoteService().subscribe({
             next: (data: any) => {
               let response:any = data;
               this.loader!.style.display = "none";            
               document.getElementById("voting-right-message")!.style.color = (response.data === 1 || response.data === -4) ? "#1FFF28" : "red";
               this.membershipError = response.data === -1;
               this.votingRightMessage = this.votingRightMessages[response.data] || "Greška!";
               response.data === 1 && (this.hasRightToVote = true);
             }, error: (error: { status: number; }) => {  
               this.loader!.style.display = "none";
             }
           })
         } else {
          this.loader!.style.display = "none"; 
         }
        }, error: (error: { status: number; }) => {  
          this.loader!.style.display = "none";       
        }
      })
    } else {
      this.loader!.style.display = "none";            
    } */
  }

  sendPIN() {
    if(sessionStorage.getItem("sendPIN")) {
      sessionStorage.removeItem("sendPIN");
    }
    this.loader!.style.display = "flex";
    if(!this.isLogged) {
      this.openLoginModal();
    } else {
      this.loader!.style.display = "flex";
      const message$ = this.apiService.getMembersRightToVoteService()
      
      forkJoin([
        message$,
      ]).subscribe(([response]) => {
        if(response.data === 1) {
          this.apiService.sendVerificationPIN().subscribe({
            next: (data: any) => {
              this.loader!.style.display = "none";
              localStorage.setItem('pinTimestamp', (new Date()).toString());
              localStorage.setItem('sentPin', "true");
              this.router.navigate(['/izbori/verifikacija']);
            }, error: (error: { status: number; }) => {         
              if(error.status === 401) {
                //this.Services.refreshToken();
              }
              this.loader!.style.display = "none";
            }
          }) 
        } else {
          document.getElementById("voting-right-message")!.style.color = response.data === 1 ? "green" : "red";
          this.votingRightMessage = this.votingRightMessages[response.data] || "Nepoznata greška";
          this.loader!.style.display = "none";
        }
      });
    }
  }

  openLoginModal() {
    this.modalService.openModal(ModalNames.Login);
  }
}
